import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50 tw-p-3 sm:tw-p-4" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-gap-2 sm:tw-flex-row sm:tw-items-center" }
const _hoisted_3 = { class: "tw-flex-1" }
const _hoisted_4 = { class: "tw-flex tw-justify-end" }
const _hoisted_5 = { class: "tw-mt-3 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-border-t tw-border-slate-200/70 tw-pt-3" }
const _hoisted_6 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-3" }
const _hoisted_7 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700" }
const _hoisted_8 = ["checked"]
const _hoisted_9 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700" }
const _hoisted_10 = ["checked"]
const _hoisted_11 = { class: "tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-justify-end tw-gap-3" }
const _hoisted_12 = { class: "tw-flex-shrink-0 tw-text-sm tw-text-slate-600 tw-whitespace-nowrap" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "tw-mx-2 tw-text-slate-400"
}
const _hoisted_16 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_17 = ["value", "onChange"]
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "tw-min-w-0 tw-overflow-x-auto" }
const _hoisted_20 = { class: "tw-flex tw-flex-nowrap tw-gap-2 tw-whitespace-nowrap tw-justify-end" }
const _hoisted_21 = { class: "tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-white/20 tw-px-2 tw-py-0.5 tw-text-xs" }
const _hoisted_22 = { class: "tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-white/20 tw-px-2 tw-py-0.5 tw-text-xs" }
const _hoisted_23 = { class: "tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-emerald-500/20 tw-px-2 tw-py-0.5 tw-text-xs" }
const _hoisted_24 = { class: "tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-rose-500/20 tw-px-2 tw-py-0.5 tw-text-xs" }
const _hoisted_25 = { class: "tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-white/20 tw-px-2 tw-py-0.5 tw-text-xs" }
const _hoisted_26 = { class: "tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-red/20 tw-px-2 tw-py-0.5 tw-text-xs" }
const _hoisted_27 = {
  key: 0,
  class: "tw-mt-3 tw-rounded-xl tw-border tw-border-indigo-200 tw-bg-indigo-50 tw-px-4 tw-py-3 tw-text-sm tw-text-indigo-900"
}
const _hoisted_28 = { class: "tw-font-semibold" }
const _hoisted_29 = { class: "tw-mt-4" }
const _hoisted_30 = {
  key: 1,
  class: "tw-mt-6 tw-flex tw-justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddNewOrderModal = _resolveComponent("AddNewOrderModal")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_OrderTable = _resolveComponent("OrderTable")!
  const _component_ListPage = _resolveComponent("ListPage")!
  const _component_PaginationBar = _resolveComponent("PaginationBar")!

  return (_openBlock(), _createBlock(_component_ListPage, {
    variant: "page",
    pageSize: _ctx.pageSize,
    "onUpdate:pageSize": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.pageSize) = $event))
  }, {
    default: _withCtx(({ pageSizeOptions, setPageSize }) => [
      _createElementVNode("div", null, [
        (_ctx.showAddModal)
          ? (_openBlock(), _createBlock(_component_AddNewOrderModal, {
              key: 0,
              open: _ctx.showAddModal,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddModal = false)),
              queryBillOfLading: _ctx.queryBillOfLading,
              onAddNewOrder: _ctx.addNewOrderHandler,
              queryCustomerId: _ctx.dropOffCustomerId
            }, null, 8, ["open", "queryBillOfLading", "onAddNewOrder", "queryCustomerId"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_SearchInput, {
                modelValue: _ctx.searchInput,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchInput) = $event)),
                onSearch: _ctx.performSearch,
                placeholder: "Search order, container, BL, customer…",
                class: "tw-w-full"
              }, null, 8, ["modelValue", "onSearch"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/orders/new'))),
                class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-slate-800"
              }, " Add New Order ")
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, [
                _createElementVNode("input", {
                  type: "checkbox",
                  id: "chk_show_imports",
                  checked: _ctx.showImports,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleShowImports && _ctx.toggleShowImports(...args))),
                  class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300"
                }, null, 8, _hoisted_8),
                _cache[13] || (_cache[13] = _createTextVNode(" Imports ", -1))
              ]),
              _createElementVNode("label", _hoisted_9, [
                _createElementVNode("input", {
                  type: "checkbox",
                  id: "chk_show_exports",
                  checked: _ctx.showExports,
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleShowExports && _ctx.toggleShowExports(...args))),
                  class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300"
                }, null, 8, _hoisted_10),
                _cache[14] || (_cache[14] = _createTextVNode(" Exports ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_ctx.ordersLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Loading…"))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.pageCount > 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Page " + _toDisplayString(_ctx.pageNum + 1) + " of " + _toDisplayString(_ctx.pageCount), 1))
                        : _createCommentVNode("", true),
                      (_ctx.pageCount > 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, "·"))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, "Showing " + _toDisplayString((_ctx.filteredOrders || []).length) + " orders", 1),
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "tw-mx-2 tw-text-slate-400" }, "·", -1)),
                      _createElementVNode("label", _hoisted_16, [
                        _cache[15] || (_cache[15] = _createElementVNode("span", null, "Rows", -1)),
                        _createElementVNode("select", {
                          class: "tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-px-2 tw-py-1 tw-text-sm tw-text-slate-800",
                          value: String(_ctx.pageSize),
                          onChange: (e) => setPageSize(Number((e.target as HTMLSelectElement).value))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageSizeOptions, (opt) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: opt,
                              value: String(opt)
                            }, _toDisplayString(opt), 9, _hoisted_18))
                          }), 128))
                        ], 40, _hoisted_17)
                      ])
                    ], 64))
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.status === _ctx.orderStatusOptions.AllActive
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-text-slate-700 hover:tw-bg-white']),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateFilterStatus(_ctx.orderStatusOptions.AllActive)))
                  }, [
                    _cache[17] || (_cache[17] = _createElementVNode("span", null, "All Active", -1)),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.nOrders.allActive), 1)
                  ], 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.status === _ctx.orderStatusOptions.InProgress
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-text-slate-700 hover:tw-bg-white']),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateFilterStatus(_ctx.orderStatusOptions.InProgress)))
                  }, [
                    _cache[18] || (_cache[18] = _createElementVNode("span", null, "In Progress", -1)),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.nOrders.inProgress), 1)
                  ], 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.status === _ctx.orderStatusOptions.Available
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-text-slate-700 hover:tw-bg-white']),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateFilterStatus(_ctx.orderStatusOptions.Available)))
                  }, [
                    _cache[19] || (_cache[19] = _createElementVNode("span", null, "Available", -1)),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.nOrders.available), 1)
                  ], 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.status === _ctx.orderStatusOptions.NotAvailable
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-text-slate-700 hover:tw-bg-white']),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateFilterStatus(_ctx.orderStatusOptions.NotAvailable)))
                  }, [
                    _cache[20] || (_cache[20] = _createElementVNode("span", null, "Not Available", -1)),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.nOrders.notAvailable), 1)
                  ], 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.status === _ctx.orderStatusOptions.Complete
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-text-slate-700 hover:tw-bg-white']),
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateFilterStatus(_ctx.orderStatusOptions.Complete)))
                  }, [
                    _cache[21] || (_cache[21] = _createElementVNode("span", null, "Complete", -1)),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.nOrders.complete), 1)
                  ], 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.status === _ctx.orderStatusOptions.Cancelled
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-text-slate-700 hover:tw-bg-white']),
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateFilterStatus(_ctx.orderStatusOptions.Cancelled)))
                  }, [
                    _cache[22] || (_cache[22] = _createElementVNode("span", null, "Cancelled", -1)),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.nOrders.cancelled), 1)
                  ], 2),
                  (_ctx.isListFiltered)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-slate-700 tw-transition hover:tw-bg-white",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.resetListFilters && _ctx.resetListFilters(...args)))
                      }, [...(_cache[23] || (_cache[23] = [
                        _createElementVNode("span", null, "Reset filters", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          (_ctx.newOrderId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _cache[24] || (_cache[24] = _createTextVNode(" Created new order: ", -1)),
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.newOrderId), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedOrders, (order) => {
          return (_openBlock(), _createElementBlock("div", {
            key: order.id
          }))
        }), 128)),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_ListPage, {
            variant: "card",
            loading: !!_ctx.ordersLoading,
            cardPadding: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_OrderTable, {
                onUpdateSortBy: _ctx.updateSortBy,
                onSelectOrder: _ctx.selectOrder,
                orders: _ctx.filteredOrders,
                sortBy: _ctx.sortBy,
                sortOrder: _ctx.sortOrder,
                lastOpenedOrderId: _ctx.lastOpenedOrderId
              }, null, 8, ["onUpdateSortBy", "onSelectOrder", "orders", "sortBy", "sortOrder", "lastOpenedOrderId"])
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        (_ctx.pageCount > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createVNode(_component_PaginationBar, {
                page: _ctx.pageNum,
                totalPages: _ctx.pageCount,
                disabled: !!_ctx.ordersLoading,
                onPreviousPage: _ctx.prevPage,
                onNextPage: _ctx.nextPage,
                onGoToPage: _ctx.goToPage
              }, null, 8, ["page", "totalPages", "disabled", "onPreviousPage", "onNextPage", "onGoToPage"])
            ]))
          : _createCommentVNode("", true),
        _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1))
      ])
    ]),
    _: 1
  }, 8, ["pageSize"]))
}